














































































































































































import { Vue, Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import has from 'lodash/has';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import NavButtonItem from '@/componentsV2/molecules/NavButtonItem/NavButtonItem.vue';
import AddressFieldDropdown from '@/componentsV2/organisms/AddressFieldDropdown/AddressFieldDropdown.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import PhoneInput from '@/components/molecules/PhoneInput/PhoneInput.vue';
import MerchantIDTooltip from '@/components/MerchantIDTooltip/MerchantIDTooltip.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import InviteMerchantSignupModalsModel from '@/views/Models/InviteMerchantSignupModalsModel.vue';
import TrashIcon from '@/components/icons/Trash.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import GoogleAddressFieldDropdown from '@/componentsV2/organisms/GoogleAddressFieldDropdown/GoogleAddressFieldDropdown.vue';

import { treatError } from '@/utils';
import { getLabelInfo } from '@/utils/getLabelInfo';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import { normalizeLocationName } from '@/utils/businessLocationHelper';

import { AddressFieldData } from '@/models/select-dropdown';
import { ILocation } from '@/models/location';
import { IOfferListItem } from '@/models/offer';

import eventBus from '@/utils/eventBus';

import HTTPStatus from '@/constants/httpStatus';

import LocationsService from '@/api/LocationsService';
import SignUpService from '@/api/SingupService';
import flagKeys from '@/constants/flagKeys';
import DateUtils from '@/utils/DateUtils';

export type LocationFormData = {
  address: AddressFieldData | null;
  aditionalAddress: string;
  locationName: string;
  merchantId: string;
  phone: {
    code: string;
    iso: string;
    number: string;
  };
};

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    AddressFieldDropdown,
    Input,
    PhoneInput,
    FilledButton,
    MerchantIDTooltip,
    Typography,
    CloseModalIcon,
    TrashIcon,
    GoogleAddressFieldDropdown
  }
})
export default class EditLocation extends Mixins(
  Vue,
  InviteMerchantSignupModalsModel
) {
  @Prop() readonly code!: string;
  @Prop() readonly businessId!: string;
  @Prop() location!: ILocation;
  @Prop({ default: false }) readonly canDeleteLocation!: boolean;
  @Prop() readonly onSuccess?: (newData?: ILocation) => void;
  observer: IntersectionObserver | null = null;

  signUpService = new SignUpService();
  locationService = new LocationsService();

  mobileModalOpened = false;

  hasTheSameLocationName = false;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  formData: LocationFormData = {
    address: null,
    aditionalAddress: '',
    locationName: '',
    merchantId: '',
    phone: {
      code: this.location.phoneCountryCode || '',
      iso: this.location.phoneCountryIso || '',
      number: ''
    }
  };

  get fullAddress() {
    return getLabelInfo(
      ['address', 'city', 'state', 'zip', 'countryName'],
      this.location || {}
    );
  }

  get initialAddressValue() {
    if (!this.location || !this.location.id) {
      return { value: null, label: null };
    }

    const fullAddress = this.fullAddress;

    return {
      value: fullAddress,
      label: fullAddress,
      additionalInformation: {
        address: this.location.address,
        cityName: this.location.city,
        countryCode: this.location.phoneCountryIso,
        countryName: this.location.countryName,
        fullAddress: fullAddress,
        postCode: this.location.zip,
        stateCode: this.location.state,
        stateName: this.location.stateName
      }
    };
  }

  mounted() {
    eventBus.$on('locationFormSetErrors', this.handleSetFormErrors);
    this.fillDefaultFormData();
  }

  beforeDestroy() {
    eventBus.$off('locationFormSetErrors', this.handleSetFormErrors);
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  handleSetFormErrors(errors: Record<string, string | string[]>) {
    const formRef = this.$refs.observer;

    formRef.setErrors(errors);
  }

  fillDefaultFormData() {
    if (!this.location) return;

    const {
      addressAdditional,
      address,
      zip,
      city,
      state,
      stateName = '',
      phoneCountryIso = '',
      phoneCountryCode = '',
      phone = '',
      merchantId = '',
      name = '',
      countryName
    } = this.location;

    this.formData = {
      ...this.formData,
      aditionalAddress: addressAdditional,
      locationName: name,
      merchantId,
      phone: {
        iso: phoneCountryIso,
        code: phoneCountryCode,
        number: phone
      },
      address: {
        address,
        fullAddress: this.fullAddress,
        postCode: zip,
        cityName: city,
        stateName,
        stateCode: state,
        countryName: countryName,
        countryCode: phoneCountryIso
      }
    };
  }

  handleClearAddress() {
    const locationNameInputEl = document.querySelector<HTMLInputElement>(
      'input[name="locationName"]'
    );

    if (locationNameInputEl) {
      locationNameInputEl.value = '';
    }

    this.formData = Object.assign({}, this.formData, {
      address: null,
      locationName: ''
    });
  }

  async handleAddressChange(addressData: any) {
    const { data } = await this.signUpService.getGoogleAdressesDetail(
      addressData.id
    );
    this.formData = Object.assign({}, this.formData, {
      address: data.location,
      locationName: normalizeLocationName(data.location.address)
    });
  }

  handleCloseMobileModal() {
    this.mobileModalOpened = false;
  }

  handleTippyClick() {
    if (!this.$mobileCheck()) return;

    this.mobileModalOpened = true;
  }

  handleCloseTooltip() {
    const triggerEl = document.querySelector('[data-tippy="merchant-tooltip"]');

    if (triggerEl) {
      triggerEl.dispatchEvent(new Event('click'));
    }
  }

  handleMID() {
    location.href = 'mailto:hello@twism.com';
  }

  formatPayload(formData: LocationFormData) {
    const {
      locationName,
      aditionalAddress,
      merchantId,
      address,
      phone
    } = formData;

    const payload = {
      ...(address && {
        address: address.address,
        city: address.cityName,
        zip: address.postCode,
        state: address.stateCode,
        stateName: address.stateName,
        addressAdditional: aditionalAddress,
        fullAddress: address.fullAddress
      }),
      locationName,
      phone: phone.number,
      phoneCountryCode: phone.code,
      phoneCountryIso: phone.iso,
      merchantId,
      primary: this.location && this.location.primary ? true : false
    };

    return payload;
  }

  handleLocationError(errorResponse: any) {
    const errorMessage = treatError(errorResponse, false);

    if (
      (has(errorResponse, 'response.data.slug') &&
        errorResponse.response.data.slug ===
          'exceptions.business.theSameLocationName') ||
      errorMessage === 'There is another business using this address'
    ) {
      this.hasTheSameLocationName = true;
      this.$el.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }

    this.$notification(errorMessage, 'error');
  }

  async handleEditLocation() {
    if (!this.location) return;

    const payload = this.formatPayload(this.formData);

    this.submitLoading = true;

    const response = await this.service.updateLocation(
      this.code,
      this.location.id,
      payload
    );

    const { data, status } = response;

    this.submitLoading = false;

    if (status !== HTTPStatus.OK) {
      this.handleLocationError(response);

      return;
    }

    if (this.onSuccess) this.onSuccess(data);

    this.onClose();
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');
      return;
    }

    this.handleEditLocation();
  }

  openDeleteConfirmation() {
    eventBus.$emit('closeModal');

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'confirmationDeleteLocation',
        mobileFullScreen: false
      }),
      {
        location: this.location,
        code: this.code
      }
    );

    return;
  }
}
